import apiInstance from '@/axios';

const BASE_URL = '/system-products';

export const systemProductApi = {
  // 모든 시스템 제품 조회
  async getAll(includeInactive = false) {
    const params = includeInactive ? { includeInactive: 'true' } : {};
    const response = await apiInstance.get(BASE_URL, { params });
    return response.data;
  },

  // 단건 조회 (ID)
  async getById(id) {
    const response = await apiInstance.get(`${BASE_URL}/${id}`);
    return response.data;
  },

  // 단건 조회 (타입)
  async getByType(type) {
    const response = await apiInstance.get(`${BASE_URL}/type/${type}`);
    return response.data;
  },

  // 수정
  async update(id, data) {
    const response = await apiInstance.put(`${BASE_URL}/${id}`, data);
    return response.data;
  },
};

export default systemProductApi;
